/*******************************************************
UNIVERSAL EVENT HANDLERS
This handles events for various interactions.
********************************************************/

import activateCloudinaryImages from "./cloudinary/activate";
import activateRippleEffect from "./ripple-effect/activate";
import activateSmartAnchorTags from "./smart-anchor-tags/activate";
import addHoverClass from "./hover/add-class";
import automaticButtonProcessing from "./button-state/automatic-button-processing";
import cancelCommentReply from "./articles/cancel-comment-reply";
import checkForWallpaperAd from "./ads/check-for-wallpaper";
import doOnWindowResize from "./window-resize/do-on-window-resize";
import expandNewsUpdate from "./player-news/expand-update";
import expandPlayerOutlook from "./player-outlooks/expand";
import fixAllWidows from "./widows/fix-all";
import getPlayerNews from "./player-news/get";
import getPlayerRankings from "./player-rankings/get";
import getPlayerRumors from "./player-rumors/get";
import hideAdContainersIfAdsAreOff from "./ads/hide-ad-containers";
import initializeCheckBoxFilters from "./filter-checkboxes/initialize";
import initializeLazyLoading from "./cloudinary/lazy-loader";
import insertFreestarStickyAds from './ads/insert-freestar-sticky-ads';
import insertVideoAds from './ads/insert-video-ads';
import loadAJAXData from "./ajax-loader/get-data";
import minimizeNewsUpdate from "./player-news/minimize-update";
import onDataChartist from "./charts/on-data";
import onDrawChartist from "./charts/on-draw";
import openConfirmationModal from "./modal-window/open-confirmation";
import openItemEditorModal from "./modal-window/open-item-editor";
import removeErrorNotificationBar from "./error-handling/remove-error-notification-bar";
import removeHoverClass from "./hover/remove-class";
import removeMissingJumpBarSectionTabs from "./jump-bar/activate";
import revealElement from "./reveal/reveal-element";
import revealSelectedFilterLink from "./filter-links/reveal-selected-filter";
import scrollToElementOnPageLoad from "./scroll-on-load/scroll-to-element-on-load";
import selectRadioButtonInRow from "./radio-button/select-radio-button-in-row";
import sendUserlistActivityEvent from "./userlist/send-activity-event";
import setMinGridWidth from "./css-grid/set-min-grid-width";
import smoothScrollPolyfill from "../../lib/_smooth-scroll-polyfill/smoothscroll";
import toggleCheckbox from "./checkboxes/toggle";
import triggerCheckBoxFilterUpdate from "./filter-checkboxes/trigger-filter-update";
import triggerClearDataFilter from "./data-filter/trigger-clear";
import triggerClearInputBox from "./input-with-clear/trigger-clear";
import triggerCloseFilterLinkSubNav from "./filter-links/trigger-close-sub-nav";
import triggerCloseModalWindow from "./modal-window/trigger-close";
import triggerCommentReply from "./articles/trigger-comment-reply";
import triggerFilterLinksRangeEditor from "./filter-links/trigger-range-editor";
import triggerFilterLinkSubNav from "./filter-links/trigger-sub-nav";
import triggerFilterTabOpen from "./filter-tabs/trigger-tab-open";
import triggerFilterTabSwitch from "./filter-tabs/trigger-tab-switch";
import triggerGetArticles from "./articles/trigger-get-articles";
import triggerGetCustomListContent from "./custom-lists/trigger-get-content";
import triggerSelectedToggleTab from "./toggle-tabs/trigger-selected-tab";
import triggerSelectedToggleTabOnResize from "./toggle-tabs/trigger-selected-on-resize";
import triggerTimePeriodChange from "./time-period-selector/trigger-time-period-change";
import triggerToggleTabSwitch from "./toggle-tabs/trigger-tab-switch";
import triggerUpdateWinnings from "./bet-calc/trigger-update-winnings";
import triggerWindowResizedListener from "./window-resize/trigger-window-resized-listener";
import updateFilterTabCounts from "./filter-tabs/update-filter-counts";
import updateRangeEditor from "./filter-links/update-range-editor";
import watchDataFilterInput from "./data-filter/watch-input";
import watchFilterTabItems from "./filter-tabs/watch-items";
import watchInputWithClearButton from "./input-with-clear/watch-input";

export default function addUniversalEventHandlers() {
  // Move debugging info from PHP into a console
  //createDebuggingConsole();

  // Sends out a custom event 'rw:window-resized' whenever the window is resized
  triggerWindowResizedListener();

  // Scroll to the first element on the page with this class (if any exist)
  scrollToElementOnPageLoad();

  // Activate Cloudinary images on the page
  activateCloudinaryImages();

  // Turn on lazy loading
  initializeLazyLoading();

  // Check for wallpaper ad
  checkForWallpaperAd();

  // Smooth Scrolling Polyfill
  // http://iamdustan.com/smoothscroll/
  smoothScrollPolyfill.polyfill();

  // Activate the ripple effect when buttons are clicked
  $(document).on("click", ".btn, .scroll-tab:not(.has-more)", activateRippleEffect);

  // Control when hover effects are used on buttons
  $(document).on(
    "touchstart mouseenter",
    "button, .btn, .news-headline, .side-nav__sub-section, .side-nav__item, .jump-link, .show-myleagues-for-player",
    addHoverClass
  );
  $(document).on(
    "mouseleave",
    "button, .btn, .news-headline, .side-nav__sub-section, .side-nav__item, .jump-link, .show-myleagues-for-player",
    removeHoverClass
  );

  // Control when hover effects are used on scroll tabs
  $(document).on("touchstart mouseenter", ".scroll-tab:not(.is-selected)", addHoverClass);
  $(document).on("mouseleave", ".scroll-tab:not(.is-selected)", removeHoverClass);

  // Open confirmation modal (set options via data attributes on trigger element and/or presets)
  $(document).on("click", ".open-confirm-modal", openConfirmationModal);

  // Open item editor modal
  $(document).on("click", ".open-item-editor-modal", openItemEditorModal);

  // Close a modal window
  $(document).on("click", ".modal-background", triggerCloseModalWindow);

  // Hide error notification bar if it's clicked on
  $(document).on("click", ".error-notification-bar", removeErrorNotificationBar);

  // Reveals an element or elements depending on the selector passed via data attribute
  $(document).on("click", ".revealer", revealElement);

  // Smart Anchor Tags
  // When an anchor tag is clicked (or the page loads), this function:
  // 1. Scrolls smoothly rather than jumping to the anchor.
  // 2. Prevents the named element from being flush with the top of the screen.
  // 3. Prevents the #hash from showing up in the URL address bar.
  $(document).on("click", 'a[href^="#"]', activateSmartAnchorTags);
  activateSmartAnchorTags();

  // Load More articles
  $(document).on("click", ".show-more-articles", triggerGetArticles);

  // Show the reply form
  $(document).on("click", ".show-reply-form", triggerCommentReply);

  // Hide the reply form
  $(document).on("click", ".hide-reply-form", cancelCommentReply);

  // Automatically add the processing state on click for buttons/links with the 'inprogress' data attribute
  $(document).on("click", "a[data-inprogress], button[data-inprogress]", automaticButtonProcessing);

  // Watch for keystrokes in a data filter input
  $(document).on("keyup", ".data-filter input", watchDataFilterInput);

  // Clear data filter input
  $(document).on("click", ".filter-clear", triggerClearDataFilter);

  // Watch for keystrokes in a input box that's using a clear button
  $(document).on("keyup", ".input-wrapper:not(.no-clear) input", watchInputWithClearButton);

  // Clear the input box (for input boxes using a clear button)
  $(document).on("click", ".input-clear", triggerClearInputBox);

  // Toggle a custom checkbox
  $(document).on("click", ".checkbox", toggleCheckbox);

  // Select a custom radio button (horizontal)
  $(document).on("click", ".radio-box", selectRadioButtonInRow);

  // Get more gamer news
  $(document).on("click", ".get-more-player-news", getPlayerNews);

  // Get more player rumors
  $(document).on("click", ".get-more-player-rumors", getPlayerRumors);

  // Get more player rankings with outlooks
  $(document).on("click", ".get-more-player-rankings-outlooks", getPlayerRankings);

  // Expand News Update in Compact Mode
  $(document).on("click", ".news-update.is-compact", expandNewsUpdate);

  // Minimize News Update
  $(document).on("click", ".news-update:not(.is-compact).allow-minimize", minimizeNewsUpdate);

  // Expand player outlook (on player pages)
  $(document).on("click", ".p-card__outlook-more:not(.is-not-subscribed)", expandPlayerOutlook);

  // Check the number of ads displayed to make sure it matches what's in the header
  //checkNumAds();

  // Hide ad containers if ads are shut off (via the "plp" url parameter)
  hideAdContainersIfAdsAreOff();

  // Fix widows in text (for specific selectors)
  fixAllWidows();

  /*****************************************************************************/
  // FILTER TABS
  // A way to filter a set of items using tabs to show only items that match a certain shared condition.
  // Example Item Set: List of players.  Example set of tabs: Positions (QB, RB, WR, TE, K)

  // Handle a filter tab switch
  $(document).on("click", ".filter-tab", triggerFilterTabSwitch);

  // Handle click on element that controls a filter tab
  $(document).on("click", ".switch-to-filter-tab", triggerFilterTabOpen);

  // If there are filter tab counters in use on the page, update the counters for each tab
  $('.filter-tab[data-count="Yes"]').doIfExists(updateFilterTabCounts);

  // If there are filter tab counters in use on the page, watch the items for changes
  $('.filter-tab[data-count="Yes"]').doIfExists(watchFilterTabItems);

  // On window resize and page load, figure out the minimum tab width so we can add
  // the correct CSS Grid styles
  const setFilterTabsGrid = () => {
    setMinGridWidth({
      containers: ".filter-tabs",
      items: ".filter-tab",
      padding: "20",
    });
  };
  setFilterTabsGrid();
  doOnWindowResize(setFilterTabsGrid);

  /******************************************************************************/

  /*****************************************************************************/
  // FILTER LINKS

  // Trigger expanding a sub-nav
  $(document).on("click", ".filter-link.has-sub-nav", triggerFilterLinkSubNav);

  // Trigger closing a sub-nav
  $(document).on("click", ".more-filter-links", triggerCloseFilterLinkSubNav);

  // Loop through all the filter link sets on the page and make sure the selected filter is visible
  $(".filter-links-wrapper > .filter-links").each(revealSelectedFilterLink);

  // Trigger the filter links range editor
  $(document).on("click", ".filter-range__edit", triggerFilterLinksRangeEditor);

  // When the filter range editor select box changes, update the "Go" button link
  $(document).on("change", ".filter-range__select-box", updateRangeEditor);

  /*****************************************************************************/
  // TOGGLE TABS

  // Handle a toggle tab switch
  $(".toggle-tabs").on("click", ".toggle-tab", triggerToggleTabSwitch);

  // Determine the correct toggle tab to be selected at the current screen size
  triggerSelectedToggleTab();

  // Determine the correct toggle tab to be selected when the screen is resized
  $(window).on("resize", triggerSelectedToggleTabOnResize);

  // Refresh one or all toggle tabs via this custom event (passing in a tab set name is optional)
  $(document).on("toggleTabs:refresh", (e, name) => {
    triggerSelectedToggleTab(name);
  });

  // On window resize and page load, figure out the minimum tab width so we can add
  // the correct CSS Grid styles
  const setToggleTabsGrid = () => {
    setMinGridWidth({
      containers: ".toggle-tabs-set.is-many .toggle-tabs",
      items: ".toggle-tab",
      padding: "10",
    });
  };
  setToggleTabsGrid();
  doOnWindowResize(setToggleTabsGrid);

  /******************************************************************************/

  /*****************************************************************************/
  // STAT BOXES

  // On window resize and page load, figure out the minimum box width so we can add
  // the correct CSS Grid styles
  const setStatBoxesGrid = () => {
    setMinGridWidth({
      containers: ".stat-boxes",
      items: ".stat-box",
      padding: "16",
    });
  };
  setStatBoxesGrid();
  doOnWindowResize(setStatBoxesGrid);

  /******************************************************************************/

  /*****************************************************************************/
  // JUMP BAR
  removeMissingJumpBarSectionTabs();

  /*****************************************************************************/
  // CUSTOM LISTS
  $(document).on("click", ".get-more-custom-list", triggerGetCustomListContent);

  /******************************************************************************/

  // Run all checkbox filters once the page loads (sets the initial state)
  initializeCheckBoxFilters();

  // Handle toggling a checkbox filter
  $(document).on("click", ".filter-checkbox", triggerCheckBoxFilterUpdate);

  // Add automated in-article text ads (if applicable)
  //$('.article').each(addInArticleTextAds);

  // Add video ads
  insertVideoAds();

  // Add Freestar Sticky Ads
  insertFreestarStickyAds();

  // Load data from all AJAX URLs set in the top of the page (this needs to run before loadTableData)
  loadAJAXData();

  // Listen for keypresses in the Webix table search boxes (if any exist)
  $(document).on("keyup", ".auto-search input", (e) => {
    const $inputBox = $(e.currentTarget);

    // Check for various keyboard actions
    const keyPressed = {
      esc: e.which === 27,
    };

    // Clear the input box if the ESC key is pressed
    if (keyPressed.esc) {
      $inputBox.val("");
    }
  });

  // USERLIST USER ACTIVITY EVENT
  // This triggers an activity event in Userlist if a specific meta tag exists on the page
  sendUserlistActivityEvent();

  // GLOBAL CHARTIST FUNCTIONS
  // Making these global so they can be used with inline scripts
  window.rwChartist = {};
  window.rwChartist.onData = onDataChartist;
  window.rwChartist.onDraw = onDrawChartist;

  // This custom event lets anyone know when the core javascript is done loading (useful for tables)
  const rwjsEvent = document.createEvent("Event");
  rwjsEvent.initEvent("rwjs:ready", true, true);
  document.dispatchEvent(rwjsEvent);

  /*****************************************************************************/
  // BET CALCULATORS

  $(document).on("keyup change", ".event__bet", triggerUpdateWinnings);

  /******************************************************************************/

  /*****************************************************************************/
  // SPORTSBOOK CHOOSER

  //$(document).on('click', '.switch-to-book', triggerChooseBook);

  /******************************************************************************/

  /*****************************************************************************/
  // TIME PERIOD CHOOSER

  $(document).on("change", ".time-period-selector", triggerTimePeriodChange);

  /******************************************************************************/
}
